<template>
  <router-link
      :to="{path:'/editor',query:{theme_id:tc.theme_id,tags:tc.tags}}"
      class="theme-card">
    <img :src="tc.src" :alt="tc.src" ref="themePreview"/>
    <div class="opt" v-if="tc.theme_id">
      <div class="btn-group">
        <a-button type="primary" block>创建活动</a-button>
      </div>
    </div>
  </router-link>
</template>

<script setup lang="ts">
import {ViewCard} from "vue-waterfall-plugin-next/dist/types/types/waterfall";
import {onMounted, ref} from "vue";

defineProps<{ tc: ViewCard }>()
const emit = defineEmits(['onLoad'])
const themePreview = ref()
onMounted(() => {
  themePreview.value.onload = () => emit('onLoad')
  if (themePreview.value.complete) emit('onLoad')
})
</script>

<style scoped lang="sass">
@import "@/main.variable"

.theme-card
  border-radius: 8px
  display: block
  background-color: white
  border: 1px transparent solid
  position: relative
  cursor: pointer

  &:hover
    box-shadow: 0 0 28px -20px #000, inset 0 0 0 1px #DDDEE1

    > .opt
      display: block

  > img
    width: calc(100% - 16px)
    border-radius: 8px
    overflow: hidden
    margin: 8px

  > .opt
    display: none
    border-radius: 8px
    margin: 8px
    position: absolute
    left: 0
    bottom: 0
    width: calc(100% - 16px)
    height: calc(100% - 16px)
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4), transparent 60px, transparent 100%)

    > .btn-group
      position: absolute
      left: 8px
      right: 8px
      top: 8px

.off-line
  .tpl-card-content
    background-color: #f5f5f5 !important

.tpl-card
  display: block
  border-radius: 10px
  overflow: hidden
  cursor: pointer
  background: #fff
  box-shadow: 0 2px 10px 0 rgba(35, 94, 147, .1)
  transition: all .3s
  margin-bottom: 12px
  position: relative

  > .industry
    background-image: url("@/assets/image/template_head_tag_bg.png")
    background-size: auto 2.7rem
    position: absolute
    left: 0
    top: 0
    width: 8.1rem
    height: 2.7rem

    > span
      display: inline-block
      width: 7rem
      text-align: center
      color: white
      line-height: 2.3rem
      font-size: 1.5rem
      font-weight: bold


  > img
    height: 100%
    width: 100%
    object-fit: cover
    transition: all .3s

  > .tpl-card-content
    height: 110px
    z-index: 2
    background-color: white
    display: flex
    flex-flow: column nowrap
    justify-content: space-between
    position: relative
    padding: 12px 10px 0 10px

    > .title
      font-size: 16px
      font-weight: 500
      color: #0e1234
      line-height: 22px
      max-height: 44px
      overflow: hidden
      text-overflow: ellipsis
      display: -webkit-box
      -webkit-box-orient: vertical
      -webkit-line-clamp: 2

    > .info
      height: 60%
      width: 100%
      border-top: 1px solid #f7f7f7
      display: flex
      align-items: center
      position: relative

      > .tags
        position: absolute
        left: 0
        opacity: 1
        transition: all .3s

      > .ant-btn
        position: absolute
        left: 0
        opacity: 0
        transition: all .3s

  &:hover
    box-shadow: 0 10px 20px 0 rgba(35, 94, 147, .2)
    transform: translateY(-10px)
    transition: all .3s

    > img
      transform: scale(1.1)

    > .tpl-card-content > .info
      > .tags
        opacity: 0
        transition: all .3s

      > .ant-btn
        opacity: 1
        transition: all .3s
</style>